import script from "./VersionarModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./VersionarModal.vue?vue&type=script&lang=ts&setup=true"

import "./VersionarModal.vue?vue&type=style&index=0&id=1d2df968&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2df968"]])

export default __exports__